import * as React from 'react';
import { removeFromTeam } from '../../../redux/actions/serverApi.actions';
import { connect, ConnectedProps } from 'react-redux';
import { InjectedTranslateProps, translate, Trans } from 'react-i18next';
import { getContributorEmailById } from '../../../redux/selectors/teamMembers';
import { reportDeleteTeamMemberConfirmed } from '../../../redux/actions/bi.actions';
import { getIsSite } from '../../../redux/selectors/config';

import { MessageBoxFunctionalLayout, Text } from 'wix-style-react';

export interface RemoveModalProps extends InjectedTranslateProps, ConnectedProps<typeof connector> {
  idToRemove: string;
  closeModal(): void;
}

export class RemoveFromTeamComponent extends React.PureComponent<RemoveModalProps> {

  onOk = async () => {
    const { onRemoveClicked, closeModal } = this.props;
    await onRemoveClicked(this.props.contributorEmailToRemove);
    closeModal();
  }

  render() {
    const { closeModal, contributorEmailToRemove, t, siteLevel } = this.props;

    return (
      <MessageBoxFunctionalLayout
        dataHook="remove-from-team-layout"
        title={t(siteLevel ? 'app.removeContributor.title' : 'app.removeFromTeam.title')}
        confirmText={t('app.removeFromTeam.removeCTA')}
        cancelText={t('app.removeFromTeam.cancelCTA')}
        onCancel={closeModal}
        onClose={closeModal}
        onOk={this.onOk}
        theme="red"
        width="540px"
      >
        <Trans i18nKey={siteLevel ? 'app.removeContributor.description' : 'app.removeFromTeam.description'} values={{ email: contributorEmailToRemove }}>
          <Text>0</Text>
          <Text weight="normal">1</Text>
          <Text>2</Text>
        </Trans>
      </MessageBoxFunctionalLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  contributorEmailToRemove: getContributorEmailById(state, ownProps.idToRemove),
  siteLevel: getIsSite(state)
});

const mapDispatchToProps = (dispatch, ownProps: {idToRemove: string}) => ({
  onRemoveClicked: (emailToRemove: string) => {
    dispatch(reportDeleteTeamMemberConfirmed(ownProps.idToRemove));
    dispatch(removeFromTeam(ownProps.idToRemove, emailToRemove));
  }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export const RemoveFromTeam = connector(translate()(RemoveFromTeamComponent));
